"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importDefault(require("styled-components"));
const common_buoy_dialog_1 = require("@buoyhealth/common.buoy-dialog");
const StyledResponsiveDialog = (0, styled_components_1.default)(common_buoy_dialog_1.ResponsiveDialog) `
  hr {
    display: none;
  }

  .MuiPaper-root .MuiDialogContent-root {
    padding-top: 0;
  }

  &.MuiDrawer-root .MuiDrawer-paper {
    height: auto;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.md}px) {
    .MuiPaper-root > div:last-of-type > div {
      padding: 1.5rem;
    }
  }

  form {
    row-gap: 1.5rem;
  }
`;
const DisclaimerModal = ({ open, onClose, Content }) => {
    return ((0, jsx_runtime_1.jsx)(StyledResponsiveDialog, { onClose: onClose, open: open, topDivider: false, variant: "temporary", withBuoyTheme: true, children: Content }));
};
exports.default = DisclaimerModal;
//# sourceMappingURL=BetaChipModal.js.map